import styled from 'styled-components'

import { h1HeaderFontProps, inSmallSpace } from '../../const/commonStyles'

export const TitleBlock = styled.h1`
  margin: 0 0 ${inSmallSpace};

  ${h1HeaderFontProps.join('')}
`
